import { assertIsError } from '@theorchard/utils-i18n';
import { getI18nOptions } from './init';
const loadI18nMessages = async (language, keys) => {
    const handler = getI18nOptions().onLoadMessages;
    const results = await Promise.all(keys.map(async (key) => await handler(language, key)));
    return results.reduce((result, module) => {
        const { key } = module.__meta__;
        return {
            ...result,
            [key]: module,
        };
    }, {});
};
const getI18nRootMessages = async (language) => await loadI18nMessages(language, [getI18nOptions().fragmentRootKey]);
const getI18nPageMessages = async (language, Page) => {
    if (Page.i18nKeys && !Page.i18nGetMessages)
        return await loadI18nMessages(language, Page.i18nKeys);
    return Page.i18nGetMessages
        ? await Page.i18nGetMessages(language, Page.i18nKeys)
        : await Promise.resolve({});
};
export const getI18nMessages = async (language, Component) => {
    try {
        return await Promise.all([
            getI18nRootMessages(language),
            getI18nPageMessages(language, Component),
        ]);
    }
    catch (e) {
        assertIsError(e);
        throw new Error(`Failed to load i18n messages for locale: "${language}". ${e.message}.`);
    }
};
//# sourceMappingURL=fetch.js.map